import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TREATMENTS } from "@/data/site";
import { Reveal } from "@/components/common/Reveal";

export const TreatmentsBento = () => (
  <section data-testid="treatments-section" className="bg-brand-soft">
    <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32 lg:px-20 lg:py-40">
      <Reveal className="mb-14 max-w-3xl">
        <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue">
          Treatments We Offer
        </span>
        <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-brand-dark md:text-5xl lg:text-6xl">
          Complete dental care, all under <span className="italic text-brand-blue">one roof</span>
        </h2>
      </Reveal>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {TREATMENTS.map((t, i) => (
          <Reveal key={t.slug} delay={(i % 3) * 0.06}>
            <Link
              to={`/${t.slug}`}
              data-testid={`treatment-card-${t.slug}`}
              className="group relative flex h-64 flex-col justify-end overflow-hidden rounded-2xl border border-brand-line"
            >
              <img
                src={t.image}
                alt={`${t.name} in Varanasi`}
                loading="lazy"
                width="640"
                height="400"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute inset-0 bg-gradient-to-t from-brand-accent/85 via-brand-accent/25 to-transparent" />
              <div className="relative p-6">
                <span className="inline-block rounded-full bg-white/15 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-white backdrop-blur-sm">
                  Dental
                </span>
                <h3 className="mt-2 font-display text-xl font-medium text-white">{t.name}</h3>
                <span className="mt-1 inline-flex items-center gap-1 text-sm font-semibold text-brand-green">
                  Learn more
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
